import { NgModule } from '@angular/core';
import { RequiredTrimValidatorDirective } from './required-trim.validator';
import { MinValidatorDirective } from './min.validator';
import { MaxValidatorDirective } from './max.validator';

@NgModule({
    declarations: [
        RequiredTrimValidatorDirective,
        MinValidatorDirective,
        MaxValidatorDirective
    ],
    exports: [
        RequiredTrimValidatorDirective,
        MinValidatorDirective,
        MaxValidatorDirective
    ]
})

export class ValidatorsModule { }
